export default __webpack_public_path__ + "static/media/4.b3e94dfe.jpg";